import axios from "axios";
import { authClient } from "./okta";
import { user, templates, channels, events } from "../stores";

class API {
  constructor({ url }) {
    this.url = url;
    authClient.tokenManager.on("renewed", function (key, newToken, oldToken) {
      // eslint-disable-next-line no-console
      console.log("Token with key", key, "has been renewed");
    });
  }

  async init() {
    if (authClient.isLoginRedirect()) {
      await authClient.handleLoginRedirect();
      const u = await authClient.getUser();
      user.set(u);
    } else if (!(await authClient.isAuthenticated())) {
      authClient.signInWithRedirect();
    } else {
      const u = await authClient.getUser();
      user.set(u);
    }
  }

  async signIn() {
    const [values, current] = await Promise.all([
      api.request({ path: "/event-values", credentials: true }),
      api.request({ path: "/events", credentials: true }),
    ]);
    templates.set(values.templates);
    channels.set(values.channels);
    events.set(current);
  }

  async signOut() {
    await authClient.tokenManager.clear();
    await authClient.signOut();
    user.set(null);
  }

  async getToken() {
    try {
      let token = await authClient.tokenManager.get("accessToken");
      if (!token) {
        throw new Error("no token");
      } else if (!authClient.tokenManager.hasExpired(token)) {
        console.debug(
          "token valid till: ",
          new Date(token.expiresAt * 1000).toLocaleString()
        );
        return `${token.tokenType} ${token.accessToken}`;
      } else {
        token = await authClient.tokenManager.renew("accessToken");
        console.debug(
          "token manually renewed till: ",
          new Date(token.expiresAt * 1000).toLocaleString()
        );
        return `${token.tokenType} ${token.accessToken}`;
      }
    } catch (e) {
      console.error("error: ", e);
      const token = await authClient.tokenManager.get("refreshToken");
      console.log("token: ", token);
      // if (!token || authClient.tokenManager.hasExpired(token))
      //   return await this.signOut();
      throw e;
    }
  }

  async request({ method = "get", path, data, headers = {}, credentials }) {
    const params = {
      method,
      baseURL: this.url,
      url: path,
      data,
      headers,
    };
    if (credentials) {
      params.headers["Authorization"] = await this.getToken();
    }
    console.log("request: ", params);
    const response = await axios(params);
    console.log("response: ", response);
    return response.data;
  }
}

const api = new API({ url: "__API_URL__" });
console.log("api just created.");

export default api;
